import React from 'react'

import "./Question.scss"

export interface IQuestion {
  questions: {
    description: string; 
  }[];
}

const Question = (props: IQuestion) => {
  const { questions } = props;
  return (
    <div className="m-question">
      <div className="m-question-linetop"></div>
        <div className="m-question-content">
          {questions.map((question, key) => (
            <h2 key={key}>{question.description}</h2>
          ))}
        </div>
        <div className="m-question-linebottom"></div>
    </div>
  )
}

export default Question
